export interface IncomingMessagePreview {
  authorName: string;
  text: string;
  avatarUrl: string | null;
  sentAt: string;
}

const previewTextLimit = 100;

const truncatePreviewText = (text: string): string =>
  text.length > previewTextLimit ? `${text.slice(0, previewTextLimit).trimEnd()}…` : text;

const safeAvatarUrl = (value: unknown): string | null => {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
  } catch {
    return null;
  }
};

const safeSentAt = (value: unknown): string => {
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    if (!Number.isNaN(parsed)) return new Date(parsed).toISOString();
  }
  return new Date().toISOString();
};

export const incomingMessagePreview = (payload: unknown): IncomingMessagePreview | null => {
  if (!payload || typeof payload !== 'object') return null;
  const candidate = payload as {
    authorName?: unknown;
    text?: unknown;
    avatarUrl?: unknown;
    sentAt?: unknown;
  };
  if (typeof candidate.text !== 'string' || !candidate.text.trim()) return null;

  const authorName =
    typeof candidate.authorName === 'string' && candidate.authorName.trim()
      ? candidate.authorName.trim()
      : 'New reply';

  return {
    authorName: authorName.slice(0, 80),
    text: truncatePreviewText(candidate.text.trim()),
    avatarUrl: safeAvatarUrl(candidate.avatarUrl),
    sentAt: safeSentAt(candidate.sentAt),
  };
};
